export const META_WEBSITE_URL = 'https://www.tictactrip.eu';
export const META_NAME = 'Tictactrip';
export const META_LOGO_URL = `${document.location.origin}/react-app/logoTextBlack.png`;
export const META_SOCIALS = [
  'https://https://www.facebook.com/tictactrip/',
  'https://https://x.com/tictactrip',
  'https://fr.linkedin.com/company/tictactrip',
  'https://www.instagram.com/tictactrip.eu/',
];
